import React from 'react';

/** A phone number as a dialable tel: URI (spaces, dots and dashes removed). */
export const telHref = (phone) => `tel:${(phone || '').replace(/[^\d+]/g, '')}`;

/**
 * The phones of an appointment's clients, as links that dial on a phone:
 * the billing client first, then the on-site client (once if the same).
 */
export default function AppointmentPhones({ appt, className = '' }) {
  const parties = [];
  const billing = appt.requesting_company;
  const onSite = appt.customer;
  if (billing && billing.phone && (!onSite || billing.id !== onSite.id)) parties.push(billing);
  if (onSite && onSite.phone) parties.push(onSite);
  if (!parties.length) return null;
  return (
    <span className={`appt-phones ${className}`.trim()}>
      {parties.map((p) => (
        <a key={p.id} href={telHref(p.phone)} onClick={(e) => e.stopPropagation()}>
          <span aria-hidden="true">✆ </span>{p.name} · {p.phone}
        </a>
      ))}
    </span>
  );
}
